import { ProductType } from '@bcf-shared-settings/settings/enums';
import { environmentCommon } from 'configs/environments/environment.common';

// eslint-disable-next-line @typescript-eslint/typedef
export const environmentBase = {
  ...environmentCommon,
  baseDomainName: 'lvbet',
  productType: ProductType.casino,
  brandI18Name: 'lvbetcom',
  brandCmsName: 'lvbetcom',
  brandName: 'LV BET',
  langs: ['en', 'hu', 'es', 'de', 'fi'],
  langsI18nMap: {
    en: 'en_US'
  },
  cmsDevicePrefix: false,
  cmsBrandNamePrefix: false,
  cmsHeadlessEnabled: true,
  ssrDefaultCacheTime: 5 * 60
};
